// Qui ho messo funzioni utili per manipolare testi.
// Al momento contiene solo decodeHTMLEntities.

export const decodeHTMLEntities = (text: string | null | undefined): string => {
    if (!text) return "";

    try {
        // Creo un DOMParser per convertire entità HTML in testo normale
        const parser = new DOMParser();
        const decodedString = parser.parseFromString(text, "text/html").body.textContent;
        return decodedString || text; // se parsing fallisce, ritorno il testo originale
    } catch (e) {
        console.error("Errore decodifica HTML entities:", e);
        return text;
    }
};
